import { graphql } from "../gql";

const getHeadToHeadPlayerGameLogQuery = graphql(`
  query GetHeadToHeadPlayerGameLog($input: OddsMarketTypesInput!) {
    event(input: $input) {
      awayTeam {
        numberfireId
        gameLog {
          gameId
          homeTeam
          score
          timestamp
          opponentTeam {
            abbreviation
            logoSVG
          }
        }
      }
      homeTeam {
        numberfireId
        gameLog {
          gameId
          homeTeam
          score
          timestamp
          opponentTeam {
            abbreviation
            logoSVG
          }
        }
      }
    }
  }
`);

export default getHeadToHeadPlayerGameLogQuery;
